import { render, staticRenderFns } from "./VenueFeed.vue?vue&type=template&id=78ed6e10"
import script from "./VenueFeed.vue?vue&type=script&lang=ts"
export * from "./VenueFeed.vue?vue&type=script&lang=ts"
import style0 from "./VenueFeed.vue?vue&type=style&index=0&id=78ed6e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports